import React from "react";
import { Grid } from "@mui/material";
import DateTimeSlotPicker from "../FormFields/dateTimeSlotPicker";

interface FormField {
  desiredDate: {
    name: string;
    label: string;
  };
  desiredTime: {
    name: string;
    label: string;
  };
}

interface ScheduleFormProps {
  formField: FormField;
  setActiveStep: (data: any) => void;
  values: any;
  setNavigationDirection: any;
  navigationDirection: any
}

const ScheduleForm: React.FC<ScheduleFormProps> = ({ formField, setActiveStep, ...props }) => {
  return (
    <React.Fragment>
      <Grid container >
        <Grid item xs={12}>
          <DateTimeSlotPicker
            dateName={formField.desiredDate.name}
            dateLabel={formField.desiredDate.label}
            timeName={formField.desiredTime.name}
            timeLabel={formField.desiredTime.label}
            setActiveStep={setActiveStep}
            calendarid={props?.values?.calendarid as string}
            popup={props?.values?.popup as boolean}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default ScheduleForm;
